import { AppointmentPractitioner } from '@dreryk/egabinet-appointment-frontend-api';

import { GroupSessionsFormController } from '../GroupSessionsForm.types';

import { GroupSessionsPractitionersInteractiveTable } from './practitioners/GroupSessionsPractitionersInteractiveTable';

type GroupSessionsPractitionersFieldProps = Pick<GroupSessionsFormController, 'register'> & {
   readonly practitioners: AppointmentPractitioner[];
};

export const GroupSessionsPractitionersField = (props: GroupSessionsPractitionersFieldProps): JSX.Element => {
   return (
      <GroupSessionsPractitionersInteractiveTable
         register={props.register}
         header={
            <GroupSessionsPractitionersInteractiveTable.Selector
               register={props.register}
               practitioners={props.practitioners}
            />
         }
      />
   );
};
